import Vue from "vue";
import VueChatScroll from 'vue-chat-scroll';
import moment from "moment";
import LoadScript from 'vue-plugin-load-script';
import Paginate from 'vuejs-paginate';
import Vuex from 'vuex';

// Use the plugin and pass along the configuration

Vue.config.productionTip = false;
Vue.use(VueChatScroll);
Vue.use(LoadScript);
Vue.use(Paginate);

function debounce(fn, delay = 300) {
    var timeoutID = null;

    return function () {
        clearTimeout(timeoutID);

        var args = arguments;
        var that = this;

        timeoutID = setTimeout(function () {
            fn.apply(that, args);
        }, delay);
    }
};

Vue.directive('debounce', (el, binding) => {
    if (binding.value !== binding.oldValue) {
        // window.debounce is our global function what we defined at the very top!
        el.oninput = debounce(ev => {
            el.dispatchEvent(new Event('change'));
        }, parseInt(binding.value) || 300);
    }
});

Vue.filter('capitalize', function (value) {
    if (!value) return '';
    value = value.toString();
    return value.charAt(0).toUpperCase() + value.slice(1)
});

Vue.filter('formatDate', function (value) {
    if (value) {
        moment.locale('de');
        return moment.unix(value/1000).format('LLL');
    }
});

// Initialize global event hub
Vue.prototype.$chatEvents = new Vue();

Vue.component(
    'chat',
    require('./views/Chat.vue').default
);

Vue.component(
    'auth-user-firebase',
    require('./components/AuthUserFirebase.vue').default
);

Vue.component(
    'chat-notifications',
    require('./components/ChatNotifications.vue').default
);



// new Vue({
//     // components: {
//     //     chat: Chat
//     // },
//     el: '#chat',
// });
